import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { createStore } from '@/store/createStore';

function useStore({ initialState } = {}) {
  const location = useLocation();
  const navigate = useNavigate();
  const locationRef = useRef(location);
  locationRef.current = location;

  const [store] = useState(() =>
    createStore({
      initialState,
      getLocation: () => locationRef.current,
      navigate,
    }),
  );

  useEffect(() => {
    if (window.Cypress) {
      window.store = store;
    }
  }, [store]);

  // Expose state for debugging. `window.store` gives a live handle (call
  // `store.getState()` anytime); `window.state` is updated on every dispatch
  // so you can grab a snapshot directly. Both are debug-only conveniences.
  useEffect(() => {
    window.store = store;
    window.state = store.getState();
    const unsubscribe = store.subscribe(() => {
      window.state = store.getState();
    });
    return unsubscribe;
  }, [store]);

  return store;
}

export { useStore };
